import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardDataTable from "./table/DashboardDataTable";

import { CloseIcon, UserIcon } from "../AdminIcons";
import { sessions } from "../constants";
import { SessionCard } from "../../pages/RequestDemoSession";
import { useGetVerifiedAndUnverifiedInstructorsQuery } from "../../services/instructor/instructorApi";
import { useGetAllSessionsQuery } from "../../services/demo-session/demoSessionApi";

const SESSIONS = [
  {
    id: 1,
    title: "Advanced Javascript",
    category: "Technology",
    instructor: "James Wilson",
    date: "2025-05-15",
    time: "14:00 - 15:30",
  },
  {
    id: 2,
    title: "Advanced Javascript",
    category: "Technology",
    instructor: "James Wilson",
    date: "2025-05-15",
    time: "14:00 - 15:30",
  },
  {
    id: 3,
    title: "Advanced Javascript",
    category: "Technology",
    instructor: "James Wilson",
    date: "2025-05-15",
    time: "14:00 - 15:30",
  },
  {
    id: 4,
    title: "Advanced Javascript",
    category: "Technology",
    instructor: "James Wilson",
    date: "2025-05-15",
    time: "14:00 - 15:30",
  },
  {
    id: 5,
    title: "Advanced Javascript",
    category: "Technology",
    instructor: "James Wilson",
    date: "2025-05-15",
    time: "14:00 - 15:30",
  },
];

const InstructorCell = ({ instructor }) => {
  return (
    <div className="flex items-center gap-2">
      <div
        className="flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold text-white"
        style={{ backgroundColor: instructor.color }}
      >
        {instructor.initials}
      </div>
      <span>{instructor.name}</span>
    </div>
  );
};

const TodaySessionsSection = () => {
  const navigate = useNavigate();
  const [isSessionsModalOpen, setIsSessionsModalOpen] = useState(false);
  const { data: instructorData } =
    useGetVerifiedAndUnverifiedInstructorsQuery();

  const pendingCount = instructorData?.data?.unverifiedInstructors ?? 0;
  const { data: sessionsData, isLoading: isSessionsLoading } =
    useGetAllSessionsQuery({
      page: 1,
      limit: 4,
    });

  useEffect(() => {
    if (!isSessionsModalOpen) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsSessionsModalOpen(false);
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleEscape);
    };
  }, [isSessionsModalOpen]);

  const columns = [
    { key: "time", label: "Time", headerClassName: "w-[18%]" },
    { key: "course", label: "Course", headerClassName: "w-[26%]" },
    {
      key: "instructor",
      label: "Instructor",
      headerClassName: "w-[22%]",
      render: (row) => <InstructorCell instructor={row.instructor} />,
    },
    { key: "session", label: "Session", headerClassName: "w-[16%]" },
    {
      key: "status",
      label: "Status",
      headerClassName: "w-[18%]",
      render: (row) => (
        <span className="rounded-full bg-[#1E40AF12] px-2 py-[3.5px] text-xs font-medium  text-[#1E40AF]">
          {row.status}
        </span>
      ),
    },
  ];

  return (
    <section className="px-5 pt-5 md:pl-6 md:pt-14 md:pr-[34px]">
      <div className=" items-start gap-5">
        <div>
          <div className="mb-4 flex items-center justify-between gap-3 w-full">
            <h2 className="sm:text-lg  font-semibold text-[#111827]">
              Sessions
            </h2>
            <button
              type="button"
              onClick={() => setIsSessionsModalOpen(true)}
              className="rounded-md bg-[#923D8C] px-3 py-1 sm:px-3.5 sm:py-1.5 text-xs sm:text-sm  text-white transition hover:bg-[#7C3376]"
            >
              View All
            </button>
          </div>

          <DashboardDataTable columns={columns} rows={sessions} />
        </div>
        {pendingCount > 0 ? (
          <aside className="rounded-xl border border-[#FEF3C7] bg-[#FFFBEB] p-3 sm:p-5">
            <div className="flex items-start gap-2 sm:gap-3">
              <div className="rounded-full bg-[#FEF3C7] p-2 text-[#D97706]">
                <UserIcon />
              </div>

              <div className="min-w-0">
                <p className="text-xs sm:text-sm font-medium  text-[#92400E] ">
                  Instructor Verification Pending.
                </p>
                <p className="text-xs sm:text-sm mt-1 2xl:max-w-[380px]  text-[#B45309] ">
                  {pendingCount} new instructors are waiting for verification to start
                  teaching.
                </p>

                <button
                  type="button"
                  onClick={() => navigate("/admin/manage-user")}
                  className="mt-3 rounded-md bg-[#D97706] px-3 sm:px-3.5 py-1 sm:py-1.5 text-xs sm:text-sm  text-white transition hover:bg-[#B96505]"
                >
                  Review Applications
                </button>
              </div>
            </div>
          </aside>
        ) : null}
      </div>

      {isSessionsModalOpen ? (
        <div
          className="fixed  inset-0 z-50 flex items-center justify-center bg-black/35 px-6 sm:px-10"
          onClick={() => setIsSessionsModalOpen(false)}
        >
          <div
            className="flex max-h-[90vh] font-['Roboto'] w-full max-w-[1515px] flex-col border border-[#D9D9D9] bg-[#fff] px-6 sm:px-8 md:px-10 lg:px-14 pt-6 sm:pt-10 md:pt-14 lg:pt-[86px]  pb-10 sm:pb-16 md:pb-20 lg:pb-28"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="relative mb-4 sm:mb-6 md:mb-8 flex max-w-[1370px] flex-none gap-4">
              <h3 className="border-b-[3px] sm:border-b-[4px]  border-[#923D8C] leading-none text-xl md:text-2xl lg:text-[27px] font-medium text-[#923D8C]">
                Sessions
              </h3>

              <button
                type="button"
                aria-label="Close sessions popup"
                onClick={() => setIsSessionsModalOpen(false)}
                className="absolute top-0 md:-top-1 lg:-top-5 right-0  "
              >
                <CloseIcon className="size-4 md:size-6 lg:size-[37px]" />
              </button>
            </div>

            <div className="max-w-[1384px] flex-1 space-y-3 sm:space-y-5 overflow-y-auto">
              {SESSIONS.map((session) => (
                <SessionCard key={session.id} session={session} />
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default TodaySessionsSection;
